import { render, staticRenderFns } from "./LayTabs.vue?vue&type=template&id=a4be8754&scoped=true&"
import script from "./LayTabs.vue?vue&type=script&lang=js&"
export * from "./LayTabs.vue?vue&type=script&lang=js&"
import style0 from "./LayTabs.vue?vue&type=style&index=0&id=a4be8754&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4be8754",
  null
  
)

export default component.exports